import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/admin/cgu`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  updateCguTemplate({commit}, payload: { id: number, template: string}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`,
      {template: payload.template},
      ).then((data) => data.data);
  },
  uploadCguTemplate({commit}, payload: { template: string, language: string }) {
    return axiosInstance.post(`${baseUrl}`,
      {template: payload.template, language: payload.language},
      ).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
